export const GET_SPECIALDONATIONS = "GET_SPECIALDONATIONS";
export const FILTER_SPECIALDONATIONS = "FILTER_SPECIALDONATIONS";
export const ADD_SPECIALDONATION = "ADD_SPECIALDONATION";
export const EDIT_SPECIALDONATION = "EDIT_SPECIALDONATION";
export const GET_SPECIALDONATION = "GET_SPECIALDONATION";
export const RESET_SPECIALDONATION = "RESET_SPECIALDONATION";
export const SPECIALDONATIONS_ERROR = "SPECIALDONATIONS_ERROR";
